import { render, staticRenderFns } from "./provement.vue?vue&type=template&id=0e05645a&scoped=true&"
import script from "./provement.vue?vue&type=script&lang=js&"
export * from "./provement.vue?vue&type=script&lang=js&"
import style0 from "./provement.vue?vue&type=style&index=0&id=0e05645a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e05645a",
  null
  
)

export default component.exports